import { FAB as MetxFAB } from "@mm/metx-design-system";
import { type ComponentPropsWithoutRef, forwardRef } from "react";

export type FABProps = ComponentPropsWithoutRef<typeof MetxFAB>;

export const FAB = forwardRef<HTMLButtonElement, FABProps>((props, ref) => <MetxFAB {...props} ref={ref} />);

FAB.displayName = "FAB";
